import { render, staticRenderFns } from "./vehicleM.vue?vue&type=template&id=6059e0af&scoped=true&"
import script from "./vehicleM.vue?vue&type=script&lang=js&"
export * from "./vehicleM.vue?vue&type=script&lang=js&"
import style0 from "./vehicleM.vue?vue&type=style&index=0&id=6059e0af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6059e0af",
  null
  
)

export default component.exports